import { Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { TestSuiteFormValues } from 'components/test-suites/forms/test-suite-form-utils'
import { useTestSuiteFormContext } from 'components/test-suites/forms/TestSuiteFormContext'
import { useTranslation } from 'hooks/use-translation'

export const TestSuiteName: React.FC = () => {
  const { canCreateAndEditTestSuites, isOfficialTestSuite } =
    useTestSuiteFormContext()

  const { trans } = useTranslation()

  const { control } = useFormContext<TestSuiteFormValues>()

  const canEdit = !isOfficialTestSuite && canCreateAndEditTestSuites

  return (
    <Stack spacing={2}>
      {canEdit && (
        <Typography variant="h6">
          {trans('test_suite.common_form_field.name')}
        </Typography>
      )}
      <Controller
        control={control}
        name="name"
        render={
          canEdit
            ? ({ field, fieldState }) => (
                <TextField
                  data-testid="test-suite-name-input"
                  label={trans('test_suite.common_form_field.name')}
                  placeholder={trans('test_suite.common_form_field.name')}
                  sx={{ mt: 1 }}
                  {...field}
                  error={Boolean(fieldState.error)}
                  helperText={fieldState.error?.message}
                />
              )
            : () => null // we need to still mount the controller so that the form stays valid
        }
      />
    </Stack>
  )
}
